import classNames from 'classnames'
import React from 'react'

export interface ViewHeaderProps {
  children: React.ReactNode
  className?: string
}

const ViewHeader: React.FC<ViewHeaderProps> = (props) => {
  const { children, className } = props

  return (
    <div
      className={classNames(
        'bg-header-bg-color w-full flex items-center justify-center',
        'tablet:bg-no-repeat tablet:bg-header tablet:bg-cover tablet:bg-top',
        'phone:bg-transparent'
      )}
    >
      <div className="w-full tablet:max-w-2xl tablet:px-1.5 desktop:max-w-7xl">
        <div
          className={classNames(
            'flex flex-col w-full pt-16 bg-no-repeat',
            'phone:px-0 phone:pt-16 phone:pb-0',
            'tablet:max-w-2xl tablet:min-h-64',
            'desktop:px-24 desktop:min-h-64 desktop:bg-header desktop:bg-cover desktop:bg-top',
            className
          )}
        >
          <div className="desktop:max-w-xs text-white tablet:mb-20 min-w-0">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewHeader
